export default "__VITE_ASSET__BsX$zL4G__"